module.exports = __webpack_public_path__ + "static/img/image004.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image004.gif
// module id = ra30
// module chunks = 1